import React from 'react';
import cx from 'classnames';
import Activity from 'entities/Activity';
import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import ChatListActivityItem from 'chat/components/ChatListActivityItem.jsx';
import ChatListNewActivityItemContainer from 'chat/containers/ChatListNewActivityItemContainer.jsx';
import Group from 'entities/Group';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';

import './styles/ChatListActivities.scss';

const MAX_NUMBER_ACTIVITY_ITEM = 2;

type Props = {
  upcomingActivities: Activity[],
  group: Group,
  selectedChatId?: ?string,
  canCreateActivity: boolean,
};

class ChatListActivities extends React.Component {
  props: Props;

  render() {
    const activities = this.props.upcomingActivities.sort((a, b) => {
      return a.getStartAt() - b.getStartAt();
    }).slice(0, MAX_NUMBER_ACTIVITY_ITEM);

    const chatListActivityItems = activities.map(activity => {
      const chatUuid = activity.getChatUuid();
      const linkTo = `/classes/${this.props.group.getCode()}/messages/${chatUuid}`;
      const selected = (
        this.props.selectedChatId &&
        this.props.selectedChatId === chatUuid
      );

      return (
        <Link key={activity.id} to={linkTo}>
          <ChatListActivityItem
            className={cx({ 'ChatListActivities-item-selected': selected })}
            activity={activity}
          />
        </Link>
      );
    });

    return (
      <div>
        {chatListActivityItems}
        {this.props.canCreateActivity &&
          <ModalTrigger modal={<ActivityCreateDialogContainer />}>
            <ChatListNewActivityItemContainer data-test="new-activity-item" />
          </ModalTrigger>
        }
      </div>
    );
  }
}

export default ChatListActivities;



// WEBPACK FOOTER //
// ./src/chat/components/ChatListActivities.jsx